import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import type { NonceApiResponse } from './nonce.types';

@Injectable({
  providedIn: 'root',
})
export class NonceService {
  private readonly httpClient = inject(HttpClient);

  private readonly nonce = signal<string | undefined>(undefined);

  async getNonce(): Promise<string | undefined> {
    const cached = this.nonce();
    if (cached !== undefined) {
      return cached;
    }

    try {
      const response = await this.fetchNonceFromApi();
      this.nonce.set(response.nonce);
      return this.nonce();
    } catch {
      return this.nonce();
    }
  }

  getCachedNonce(): string | undefined {
    return this.nonce();
  }

  private fetchNonceFromApi(): Promise<NonceApiResponse> {
    return firstValueFrom(
      this.httpClient.get<NonceApiResponse>(`${environment.apiUrl}/nonce`, {
        withCredentials: true,
      }),
    );
  }
}
